// extracted by mini-css-extract-plugin
export default {"centered":"FormHeader_centered__ubBVf","title":"FormHeader_title__9jM2c","subtitle":"FormHeader_subtitle__mv-Hd"};